import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class UtilHttp {
  constructor(protected httpService: HttpService) {}

  getFileUploadUrl = async (fileName, location) =>
    this.httpService.post('/media/uploads/signed-upload-url', {
      files: [fileName],
      location,
    });

  newsFeeds = async () => await this.httpService.get('/news-feeds');

  submitFeedback = async (feedback) => await this.httpService.post('/feedback', feedback);
  uploadImage = async (uploadImageData) =>
    await this.httpService.post(`/products/convert-image-PDF`, uploadImageData, { observe: 'response' });
  uploadSignUpAttachments = async (uploadImageData) => await this.httpService.post(`/products/upload-product-signup-docs`, uploadImageData);
  uploadWebCamScreens = async (base64Data) => await this.httpService.post(`/products/upload-product-signup-docs`, base64Data);
  getBase64String = async (uploadImageData) => await this.httpService.post(`/products/get-base64-string`, uploadImageData);
  // getBase64StringUsingS3 = async (s3Url) => await this.httpService.post(`/products/get-base64-string?s3Url=${s3Url}`);
  getBase64StreamUsingS3 = async (s3Url) => await this.httpService.unthorisedWithTokenPost(`/products/get-base64-stream?s3Url=${s3Url}`);
  downloadFile = async (data) => await this.httpService.unthorisedWithTokenPost(`/media/download`, data);
  disabledUserAlert = async () => await this.httpService.get('/users/disable-new-feature-alert');
  inviteaFriend = async (values) =>
    await this.httpService.get(
      `/users/invite?email=${values.email}&name=${values.name}${(values.mobile && '&mobile=' + values.mobile) || ''}`
    );
  requestAFeedback = async (values) =>
    await this.httpService.post(
      `/feedback/send-feedback-form?customerId=${values.id}&accountType=${values.accType}&emailAddresses=${values.emails}`
    );
  uploadaunauthorizedImage = async (uploadImageData) =>
    await this.httpService.post(`/media/uploads/ipo-docs`, uploadImageData, { observe: 'response' });

  publicUploads = async (uploadImageData) => await this.httpService.post(`/media/public-uploads`, uploadImageData, { observe: 'response' });
  getUTDownloadLinks = async () => await this.httpService.get(`/ut-request/downloads`);

  uploadPrivateFile = async (file) => await this.httpService.post(`/media/private-uploads`, file, { observe: 'response' });
}

@Injectable()
export class UtilService {
  constructor(protected http: UtilHttp) {}

  async getFileUploadUrl(fileName, location) {
    if (!location) {
      location = 'uploads';
    }
    return await this.http.getFileUploadUrl(fileName, location);
  }

  newsFeeds = async () => await this.http.newsFeeds();

  submitFeedback = async (feedback) => await this.http.submitFeedback(feedback);

  async uploadPrivateFile(file) {
    return await this.http.uploadPrivateFile(file);
  }

  async uploadImage(uploadImageData) {
    return await this.http.uploadImage(uploadImageData);
  }
  async uploadSignUpAttachments(uploadImageData) {
    return await this.http.uploadSignUpAttachments(uploadImageData);
  }
  async uploadWebCamScreens(base64Data) {
    return await this.http.uploadWebCamScreens(base64Data);
  }
  async getBase64String(uploadImageData) {
    return await this.http.getBase64String(uploadImageData);
  }
  async getBase64StreamUsingS3(s3Url) {
    return await this.http.getBase64StreamUsingS3(s3Url);
  }
  async downloadFile(data) {
    return await this.http.downloadFile(data);
  }
  async disabledUserAlert() {
    return await this.http.disabledUserAlert();
  }
  async inviteaFriend(values) {
    return await this.http.inviteaFriend(values);
  }
  async requestAFeedback(values) {
    return await this.http.requestAFeedback(values);
  }
  async uploadaunauthorizedImage(uploadImageData) {
    return await this.http.uploadaunauthorizedImage(uploadImageData);
  }
  async publicUploads(uploadImageData) {
    return await this.http.publicUploads(uploadImageData);
  }
  async getUTDownloadLinks() {
    return await this.http.getUTDownloadLinks();
  }
}
